<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M3,2C3,2,13,2,13,2C13.55,2,14,1.55,14,1C14,0.45,13.55,0,13,0C13,0,3,0,3,0C2.45,0,2,0.45,2,1C2,1.55,2.45,2,3,2C3,2,3,2,3,2ZM12,13C12,13,4,13,4,13C4,13,4,10,4,10C4,10,2,10,2,10C2,10,2,15,2,15C2,15.55,2.45,16,3,16C3,16,13,16,13,16C13.55,16,14,15.55,14,15C14,15,14,10,14,10C14,10,12,10,12,10C12,10,12,13,12,13C12,13,12,13,12,13ZM16,7C16,7,14.99,3.83,14.99,3.83C14.9,3.36,14.49,3,14,3C14,3,2,3,2,3C1.51,3,1.1,3.36,1.02,3.83C1.02,3.83,0.01,7,0.01,7C0.01,7,0,7,0,7C0,8.1,0.9,9,2,9C3.1,9,4,8.1,4,7C4,8.1,4.9,9,6,9C7.1,9,8,8.1,8,7C8,8.1,8.9,9,10,9C11.1,9,12,8.1,12,7C12,8.1,12.9,9,14,9C15.1,9,16,8.1,16,7C16,7,16,7,16,7C16,7,16,7,16,7Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Shop',
} as DefineComponent
</script>
